import React from 'react'
import ImageGallery from '../Components/ImageGallery/ImageGallery';
import Newsletter from '../Components/Newsletter/Newsletter';

const GallaryPage = () => {
  return (
    <div>
      
      
      <ImageGallery />
      <Newsletter />
      

    </div>
  )
}

export default GallaryPage
